export default "__VITE_ASSET__COh5lMwS__"